import validator from "../validator/validator";

export const click = (idOrClass, callback) => {
    document.addEventListener("click", (event) => {
        const element = event.target;

        if (
            element.getAttribute("id") !== idOrClass &&
            !element.classList.contains(idOrClass)
        ) {
            return;
        }

        event.preventDefault();
        element.disabled = true;

        callback(element);
    });
};

export const change = (idOrClass, callback) => {
    document.addEventListener("change", (event) => {
        const element = event.target;

        if (
            element.getAttribute("id") !== idOrClass &&
            !element.classList.contains(idOrClass)
        ) {
            return;
        }

        event.preventDefault();
        element.disabled = true;

        callback(element);
    });
};

export const submit = (idOrClass, formErrorId, formMessageId, callback) => {
    document.addEventListener("submit", (event) => {
        const element = event.target;

        if (validator.isNotValid(element)) {
            return;
        }

        if (
            element.getAttribute("id") !== idOrClass &&
            !element.classList.contains(idOrClass)
        ) {
            return;
        }

        event.preventDefault();

        let formError = null;
        let formMessage = null;

        if (formErrorId) {
            formError = document.getElementById(formErrorId);

            if (formError) {
                formError.textContent = "";
            }
        }

        if (formMessageId) {
            formMessage = document.getElementById(formMessageId);

            if (formMessage) {
                formMessage.textContent = "";
            }
        }

        const button = element.querySelector('button[type="submit"]');
        button.disabled = true;
        const formData = new FormData(element);

        callback(formData, button, formError, formMessage, element);
    });
};

export const input = (idOrClass, callback) => {
    document.addEventListener("input", (event) => {
        const element = event.target;

        if (
            element.getAttribute("id") !== idOrClass &&
            !element.classList.contains(idOrClass)
        ) {
            return;
        }

        callback(element);
    });
};
